import { patch } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import {
  workerStatusRequestSchema,
  type WorkerStatusResponse,
  workerStatusResponseSchema,
} from "../types";
import { useCurrentUserId } from "../useCurrentUserId";
import { getWorkerHomeHealthEnabledQueryKey } from "./useIsWorkerHomeHealthEnabled";

const WORKER_HOME_HEALTH_ENABLED_URL = `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/:workplaceId/workers/:workerId`;

export function useUpdateHomeHealthWorkerStatus(
  workerId: string,
  options: UseMutationOptions<WorkerStatusResponse, unknown, boolean> = {}
) {
  const queryClient = useQueryClient();

  const workplaceId = useCurrentUserId() ?? "";

  return useMutation({
    mutationFn: async (newStatus: boolean) => {
      const response = await patch({
        url: WORKER_HOME_HEALTH_ENABLED_URL.replace(":workplaceId", workplaceId).replace(
          ":workerId",
          workerId
        ),
        data: {
          data: {
            type: "worker",
            attributes: {
              homeHealthEnabled: newStatus,
            },
          },
        },
        responseSchema: workerStatusResponseSchema,
        requestSchema: workerStatusRequestSchema,
      });
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.setQueryData(getWorkerHomeHealthEnabledQueryKey({ workplaceId, workerId }), data);
    },
    ...options,
  });
}
